import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Redirect } from "react-router-dom";
import styled from "styled-components";

import { loginUser } from "../../actions/authActions";
import { getAuth } from "../../actions/authActions";
import {
  Form,
  FormGroup,
  FormControl,
  ButtonSubmit,
  ErrorMessage,
} from "../../styles/form";
import loadingGif from "../../assets/loading.gif";

const LoadingText = styled.h1`
  color: #666;
  margin: 0;
  padding: 0;
  font-size: 1.75rem;
  letter-spacing: 2px;
  margin-bottom: 16px;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const H1 = styled.h1`
  font-size: 1.5rem;
`;

class LoginForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);

    this.state = {
      email: "",
      password: "",
      loading: false,
    };
  }

  componentDidMount() {
    this.props.getAuth();
  }

  handleInputChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  async handleSubmit(event) {
    event.stopPropagation();
    event.preventDefault();
    const { email, password } = this.state;
    this.setState({ loading: true });
    await this.props.loginUser(email, password);
    this.setState({ password: "", loading: false });
  }

  renderLogin() {
    return (
      <Form onSubmit={this.handleSubmit}>
        <H1>Login</H1> <br />
        {this.props.fail_message ? (
          <ErrorMessage>{this.props.fail_message}</ErrorMessage>
        ) : null}
        <FormGroup controlid="Email">
          {/* <ControlLabel>Email</ControlLabel> */}
          <FormControl
            name="email"
            autoFocus
            type="email"
            placeholder="Email"
            ref="email"
            value={this.state.email}
            required
            onChange={this.handleInputChange}
          />
        </FormGroup>
        <FormGroup controlid="Password">
          {/* <ControlLabel>Code</ControlLabel> */}
          <FormControl
            name="password"
            type="password"
            placeholder="Password"
            ref="password"
            value={this.state.password}
            required
            onChange={this.handleInputChange}
          />
        </FormGroup>
        <ButtonSubmit
          disabled={!(this.state.email && this.state.password)}
          type="submit"
          value="Login"
        ></ButtonSubmit>
      </Form>
    );
  }

  render() {
    var state_of_login;

    if (this.props.user) {
      state_of_login = "redirect";
    } else if (this.state.loading) {
      state_of_login = "loading";
    }

    switch (state_of_login) {
      case "redirect":
        return <Redirect to="/companies" />;
      case "loading":
        return (
          <div>
            <img
              style={{
                margin: "auto",
                display: "block",
                width: "150px",
                height: "150px",
              }}
              src={loadingGif}
              alt="loading..."
            />
            <LoadingText style={{ textAlign: "center" }}>
              Loading Companies...
            </LoadingText>
          </div>
        );
      default:
        return (
          <React.Fragment>
            <Wrapper>{this.renderLogin()}</Wrapper>
            <p style={{ textAlign: "center", marginTop: "20px" }}>
              <a href="/forgot-password">Forgot password?</a>
            </p>
          </React.Fragment>
        );
    }
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth.user,
    fail_message: state.auth.fail_message,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      loginUser,
      getAuth,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);



// WEBPACK FOOTER //
// ./src/components/pages/LoginForm.js